import React from 'react';
import { formatNumber } from '../../utils/analytics-helpers';
import './WorldMap.css';

/**
 * WorldMap - Simple visualization of users by country
 * Uses country code mapping to display data on a world map
 */
const WorldMap = ({ data = [] }) => {
  // Handle empty or invalid data
  if (!data || data.length === 0) {
    return (
      <div className="world-map">
        <div className="map-header">
          <h4>Users by Country</h4>
        </div>
        <div className="map-container">
          <div style={{
            padding: 'var(--spacing-xl)',
            textAlign: 'center',
            color: 'var(--gray-500)',
            fontFamily: 'var(--font-body)'
          }}>
            No geographic data available
          </div>
        </div>
      </div>
    );
  }

  // Get max value for scaling
  const maxUsers = Math.max(...data.map(d => d.users || 0), 1);

  // Get color intensity based on user count
  const getColor = (users) => {
    const intensity = users / maxUsers;
    if (intensity > 0.7) return '#1E40AF'; // Dark blue
    if (intensity > 0.4) return '#3B82F6'; // Medium blue
    if (intensity > 0.2) return '#60A5FA'; // Light blue
    return '#DBEAFE'; // Very light blue
  };

  return (
    <div className="world-map">
      <div className="map-header">
        <h4>Users by Country</h4>
      </div>

      <div className="map-container">
        {/* Simple bar chart representation for now */}
        <div className="country-bars">
          {data.slice(0, 10).map((country, index) => (
            <div key={index} className="country-bar-item">
              <div className="country-info">
                <span className="country-name">{country.country || 'Unknown'}</span>
                <span className="country-users">{formatNumber(country.users || 0)}</span>
              </div>
              <div className="country-bar-track">
                <div
                  className="country-bar-fill"
                  style={{
                    width: `${Math.max(5, ((country.users || 0) / maxUsers) * 100)}%`,
                    background: getColor(country.users || 0)
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {data.length > 10 && (
        <div className="map-footer">
          <span className="footer-text">
            Showing top 10 of {data.length} countries
          </span>
        </div>
      )}
    </div>
  );
};

export default WorldMap;
